import { render, staticRenderFns } from "./post-basic-detail.vue?vue&type=template&id=5ee5793a"
import script from "./post-basic-detail.vue?vue&type=script&lang=js"
export * from "./post-basic-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports